import { Link } from 'react-router-dom';
import LoginIcon from '@mui/icons-material/Login';
import '../styles.css';


const NavBarLandingPage = () => {

    return (
        <nav className='navbar-horizontal'>
        <ul>
            <li><Link to="/"><img src="/logo.svg" alt="logo"/></Link></li>
            <li><Link to="/plans">Plans</Link></li>
            <li><Link to="/sign-up">Sign Up</Link></li>
        </ul>
        <div className='icon-wrapper'><Link to="/login">
        <div className='icon-custom color-white'><LoginIcon/></div></Link></div>
        </nav>
    );
}

export default NavBarLandingPage;